import React from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const CustomToast = () => {
  // ✅ Function to show toast
  // const showToast = (message, type = 'warning') => {
  //   toast[type](message, {
  //     position: 'bottom-right',
  //     autoClose: 2000,
  //     hideProgressBar: true,
  //     closeOnClick: true,
  //     pauseOnHover: true,
  //     draggable: true,
  //     style: {
  //       color: '#fff',
  //       borderRadius: '10px',
  //       boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)', // Subtle shadow
  //       padding: '10px',
  //       fontWeight: '500',
  //     },
  //   });
  // };

  return (
    <>
      <ToastContainer
        position="top-center"
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        toastStyle={{ 
          borderRadius: '10px', /* Rounded corners */
          boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)', /* Subtle shadow */
          padding: '10px',
          backgroundColor: '#FFBF00' , // Orange for warning, green for success
          color:"white"
        }}
        style={{
          marginBottom: '2rem',
        }}
      />
    </>
  );
};

export default CustomToast;
